export default class Expandable {
    constructor(el) {
        this.el = el;
        this.identifier = el.dataset.expandableId;
        this.trigger = el.querySelector(`.expandable__trigger`);
        this.content = el.querySelector(`.expandable__content`);
        this.expanded = el.classList.contains('expandable--expanded');

        this.content.addEventListener('transitionend', () => {
            this.content.style.height = null;
        });

        this.trigger.addEventListener('click', e => {
            e.preventDefault();
            this.toggle();
        });
    }

    expand() {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.expanded = true;
        this.el.classList.add('expandable--expanded');
        this.trigger.classList.add('expanded');
        this.content.classList.add('expanded');
    }

    collapse() {
        this.content.style.height = `${this.content.scrollHeight}px`;
        setTimeout(() => {
            this.content.style.height = 0;
            this.expanded = false;
            this.el.classList.remove('expandable--expanded');
            this.trigger.classList.remove('expanded');
            this.content.classList.remove('expanded');
        });
    }

    toggle() {
        if (this.expanded) {
            this.collapse();
        } else {
            this.expand();
        }
    }
}
